export default () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M11.629 7.30588C11.7431 7.38219 11.8366 7.48544 11.9012 7.60649C11.9659 7.72753 11.9997 7.86265 11.9997 7.99988C11.9997 8.13711 11.9659 8.27223 11.9012 8.39328C11.8366 8.51433 11.7431 8.61757 11.629 8.69388L5.228 12.8709C4.695 13.2179 4 12.8249 4 12.1759V3.82388C4 3.17488 4.695 2.78188 5.228 3.12888L11.629 7.30588Z" fill="white" />
    </svg>
)
